import React from 'react'
import { CloseCircle, TickCircle } from 'iconsax-react'
import styled from 'styled-components'

export const REPORT_TOAST_MS = 3000

const Card = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(--t-spacing-2-5, 10px);
  max-width: min(90vw, 420px);
  padding: var(--t-spacing-3, 14px) var(--t-spacing-4, 16px);
  border-radius: var(--t-border-radius-md, 10px);
  background: var(--color-surface);
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm, 13px);
  font-weight: var(--t-typography-font-weight-medium, 500);
  box-shadow:
    0 0 0 1px var(--t-opacity-primary-10, rgba(48, 99, 253, 0.1)),
    0 8px 24px -6px rgba(48, 99, 253, 0.35);
  animation: report-toast-in 0.18s ease;

  svg {
    flex-shrink: 0;
    color: var(--primary);
  }

  @keyframes report-toast-in {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

const DismissButton = styled.button`
  display: inline-flex;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  margin-left: var(--t-spacing-1, 4px);
  color: var(--color-text-secondary);

  &:hover {
    color: var(--color-text);
  }
`

export const ToastAnchor = styled.div`
  position: fixed;
  right: 40px;
  bottom: 40px;
  z-index: 60;
`

const ReportToast = ({ message, onClose }) => (
  <Card role="status" id="CampaignReport_Toast" data-testid="CampaignReport_Toast">
    <TickCircle size={16} variant="Bold" />
    <span id="CampaignReport_Toast_message" data-testid="CampaignReport_Toast_message">
      {message}
    </span>
    <DismissButton
      type="button"
      id="CampaignReport_Toast_Dismiss_button"
      data-testid="CampaignReport_Toast_Dismiss_button"
      aria-label="Dismiss notification"
      onClick={onClose}
    >
      <CloseCircle size={16} variant="Outline" />
    </DismissButton>
  </Card>
)

export const reportToast = (message) => ({
  component: <ReportToast message={message} />,
  timeToDisappear: REPORT_TOAST_MS,
})

export default ReportToast
